import { ButtonVariant } from '../../utils/buttonStyles.js';
import { getSidePanelFooterStyles, getFiltersFooterButtonStyles } from './SidePanelDefaultFooterStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Button } from '../Button/Button.js';

const SidePanelDefaultFooter = _ref => {
  let {
    submitText,
    cancelText,
    isCancelBtnDisabled,
    isSubmitBtnDisabled,
    submitBtnType = 'button',
    submitBtnForm,
    onClickCancel,
    onClickSubmit,
    ...rest
  } = _ref;
  return jsxs("footer", {
    css: getSidePanelFooterStyles,
    ...rest,
    children: [jsx(Button, {
      css: getFiltersFooterButtonStyles,
      variant: ButtonVariant.OUTLINED,
      onClick: onClickCancel,
      disabled: isCancelBtnDisabled,
      children: cancelText
    }), jsx(Button, {
      css: getFiltersFooterButtonStyles,
      variant: ButtonVariant.FILLED,
      onClick: onClickSubmit,
      disabled: isSubmitBtnDisabled,
      type: submitBtnType,
      form: submitBtnForm,
      children: submitText
    })]
  });
};

export { SidePanelDefaultFooter };
//# sourceMappingURL=SidePanelDefaultFooter.js.map
